import { NavLink, useLocation } from 'react-router-dom';
import { Home, TrendingUp, MapPin, Bell, User } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useAuthContext } from '@/contexts/auth';

/**
 * Mobile-only bottom navigation for primary sections.
 * Hidden on ≥md viewports and on dashboard/admin routes.
 * Uses safe-area-inset for iOS.
 */
export function MobileBottomNav() {
  const location = useLocation();
  const { user } = useAuthContext();

  const hiddenPrefixes = ['/dashboard', '/admin', '/auth', '/register', '/verify', '/reset-password'];
  if (hiddenPrefixes.some((p) => location.pathname.startsWith(p))) {
    return null;
  }

  const items = [
    { to: '/', label: 'Home', icon: Home, exact: true },
    { to: '/prezzo-oro-oggi', label: 'Prezzi', icon: TrendingUp },
    { to: '/compro-oro', label: 'Vicino', icon: MapPin },
    { to: '/avvisi', label: 'Avvisi', icon: Bell },
    { to: user ? '/profile' : '/login', label: user ? 'Profilo' : 'Accedi', icon: User },
  ];

  return (
    <nav
      aria-label="Navigazione principale mobile"
      className={cn(
        'md:hidden fixed bottom-0 inset-x-0 z-40',
        'bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/80',
        'border-t border-border',
        'pb-safe'
      )}
    >
      <ul className="flex items-stretch justify-around">
        {items.map(({ to, label, icon: Icon, exact }) => (
          <li key={to} className="flex-1">
            <NavLink
              to={to}
              end={exact}
              className={({ isActive }) =>
                cn(
                  'flex flex-col items-center justify-center gap-0.5 py-2 px-1 text-[11px] font-medium min-h-[52px] transition-colors',
                  isActive
                    ? 'text-primary'
                    : 'text-muted-foreground hover:text-foreground'
                )
              }
              aria-label={label}
            >
              <Icon className="h-5 w-5" aria-hidden="true" />
              <span>{label}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
